import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import type { RootState } from '@/store/rootReducer';
import {
  nextStep, setData
} from '@/store/slices/registration/registrationSlice';
import PasswordForm from '@/components/organism/Registration/PasswordForm';
import EmailConfirmation from '@/components/organism/Registration/EmailConfirmation';
import PhoneConfirmation from '@/components/organism/Registration/PhoneConfirmation';
import RegistrationSuccess from '@/components/organism/Registration/RegistrationSuccess';
import UsernameForm from '@/components/organism/Registration/UserForm';
import type { RegistrationData, RegistrationStep } from '@/types/auth/Auth';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- shared component types vary
const stepComponentMap: Record<RegistrationStep, React.ComponentType<any>> = {
  otp: UsernameForm,
  password: PasswordForm,
  emailCode: EmailConfirmation,
  phoneCode: PhoneConfirmation,
  complete: RegistrationSuccess,
};

const RegisterStepper: React.FC = () => {
  const dispatch = useDispatch();
  const { step, data, loading, error } = useSelector((state: RootState) => state.registration);

  const CurrentStep = stepComponentMap[step];

  const handleNext = (formValues: RegistrationData) => {
    dispatch(setData(formValues));
    dispatch(nextStep());
  };

  // For thunks, you can call thunk actions here if needed.

  return (
    <CurrentStep
      formData={data}
      onNext={handleNext}
      loading={loading}
      error={error}
    />
  );
};

export default RegisterStepper;
